(() => {
  if (customElements.get('yamsuph-deck')) return;
  customElements.define('yamsuph-deck', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.cards = [...this.querySelectorAll('[data-draw-card]')];
      this.panel = this.querySelector('.yg-selection');
      if (!this.cards.length || !this.panel) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const pick = (event) => {
        const card = event.target.closest('[data-draw-card]');
        if (card && this.contains(card)) this.draw(card);
      };
      this.addEventListener('click', pick, { signal });
      this.addEventListener('focusin', pick, { signal });
      this.addEventListener('pointerover', (event) => {
        if (event.pointerType === 'mouse') pick(event);
      }, { signal });
      this.addEventListener('keydown', (event) => {
        const index = this.cards.indexOf(event.target);
        if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index + (event.key === 'ArrowRight' ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.cards.length - 1;
        const card = this.cards[Math.max(0, Math.min(this.cards.length - 1, next))];
        card.focus({ preventScroll: true });
        card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
      }, { signal });
      this.dataset.ready = '';
      this.draw(this.cards[0]);
    }

    draw(card) {
      if (card === this.selected) return;
      if (this.selected) {
        this.selected.setAttribute('aria-pressed', 'false');
        this.selected.closest('.yg-card').classList.remove('is-drawn');
      }
      this.selected = card;
      card.setAttribute('aria-pressed', 'true');
      card.closest('.yg-card').classList.add('is-drawn');
      this.querySelector('[data-selected-title]').textContent = card.dataset.title;
      this.querySelector('[data-selected-price]').textContent = card.dataset.price;
      this.querySelector('[data-selected-stock]').textContent = card.dataset.available === 'false' ? card.dataset.soldOut : '';
      this.querySelector('[data-selected-link]').setAttribute('href', card.dataset.url);
      this.panel.hidden = false;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.selected = null;
    }
  });
})();
